// Constants

export const info_nomina = () => {
    return {
        info_nomina: {
            id: {
                namepath: ["afiliado_nomina"],
                description: 'id autoincrement',
                label: 'Id',
                name: 'solId',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: null
                }
            },
            id_list_documento: {
                namepath: ["afiliado_nomina"],
                type: 'select',
                label: 'Tipo',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_documento",
                    label: 'name'
                },
            },
            id_datos_razon: {
                namepath: ["afiliado_nomina"],
                type: 'select',
                label: 'Razón social',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_razon",
                    label: 'name'
                },
            },
            id_datos_afiliado: {
                namepath: ["afiliado_nomina"],
                type: 'select',
                label: 'Afiliado',
                placeholder: '',
                description: 'Afiliado',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_afiliado",
                    label: 'name'
                },
            },
            name: {
                type: "text",
                label: "Nombres",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            documento: {
                type: "number",
                label: "N° Documento",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    prepend: '',
                    append: '',
                    predeterminate: '',
                }
            },
            fecha: {
                type: "date",
                label: "Fecha",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: true,
                    predeterminate: null,
                }
            },
            fechaini: {
                type: "date",
                label: "Fecha Inicial",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fechafin: {
                type: "date",
                label: "Fecha final",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cargo: {
                type: "text",
                label: "Cargos",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            salario: {
                type: "number",
                label: "salario",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "$"
                }
            },
            valor: {
                type: "number",
                label: "Total",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: true,
                    predeterminate: 0,
                    prepend: "$"
                }
            },
        }
    }
}